<template>
 <div class="page">
    <login-navigator></login-navigator>
    <logo-header></logo-header>
    <main-navigator :currentIndex="currentIndex"></main-navigator>
    <bread><span slot="nav" style="color:#00A0E9" >{{navList[curIndex].name}}</span></span></bread>
    <section class="main">
      <ul>
            <li class="item" v-for="(item,index) in list">
              <div class="left">
                <img :src="item.thumb_img !=null?item.thumb_img:imgPath[curIndex].path" alt="">
                <!-- <img src="../static/img/1.png" alt=""> -->
              </div>
              <div class="right">
                <div class="des">
                  <h3>{{item.title}}</h3>
                  <span class="price">{{item.price}}</span>
                  <span class="recruit">{{item.address}}</span>
                </div>
                <router-link :to="{path:'detail',query:{id:item.id,navid:currentIndex,navindex:curIndex}}"><span class="enroll">报名</span></router-link>
              </div>
            </li>
          </ul>
    </section>
 </div>
</template>

<script>
import LoginNavigator from "../components/LoginNavigator";
import LogoHeader from "../components/LogoHeader";
import Bread from "../components/Bread";
import MainNavigator from "../components/MainNavigator";
import qs from "qs";
export default {
  data() {
    return {
      list: [],
      curIndex: 0,
      navList: [],
      imgPath: [
        {
          path: require("../assets/1.png")
        },
        {
          path: require("../assets/2.png")
        },
        {
          path: require("../assets/15.png")
        },
        {
          path: require("../assets/16.png")
        },
        {
          path: require("../assets/17.png")
        },
        {
          path: require("../assets/18.png")
        },
        {
          path: require("../assets/19.png")
        },
        {
          path: require("../assets/20.png")
        },
        {
          path: require("../assets/21.png")
        },
        {
          path: require("../assets/22.png")
        }
      ]
    };
  },
  beforeCreate() {},
  created() {
    this.getNavList();
  },
  computed: {
    currentIndex() {
      console.log("id", this.$route.query.id);
      return parseInt(this.$route.query.id);
    }
  },
  mounted() {},
  watch: {
    $route(to, from) {
      this.getParentInfo();
    }
  },
  methods: {
    getNavList: function() {
      let that = this;
      that.$axios
        .post(
          "http://imgurl120.moontion.cn/cyy/wy/employ/index.php/Employ/getParentCateInfo"
        )
        .then(res => {
          if (res.data.success) {
            var list = res.data.info;
            that.navList = list;
            console.log("navList", that.navList);
            this.getParentInfo();
          }
        });
    },
    getParentInfo: function() {
      let that = this,
        id = that.currentIndex;
      let postData = {
        id: id
      };
      that.$axios
        .post(
          "http://imgurl120.moontion.cn/cyy/wy/employ/index.php/Employ/getParentInfo",
          qs.stringify(postData)
        )
        .then(res => {
          console.log("res.data", res.data);
          if (res.data.success) {
            this.list = res.data.info;
            let list = this.navList;
            let id = this.$route.query.id;
            let num = list.findIndex(x => {
              return x.id == id;
            });
            if (num >= 0) {
              this.curIndex = num;
            }
          }
        });
    },
    getInfoId: function() {
      let that = this,
        id = that.currentIndex;
      let postData = {
        id: id
      };
      that.$axios
        .post(
          "http://imgurl120.moontion.cn/cyy/wy/employ/index.php/Employ/getInfoId",
          qs.stringify(postData)
        )
        .then(res => {
          console.log(res);
        });
    }
  },
  components: {
    Bread,
    LoginNavigator,
    LogoHeader,
    MainNavigator
  }
};
</script>

<style scoped>
.page {
  background: #f5f5f5;
}
.main {
  width: 1200px;
  margin: 0 auto;
  background: #fff;
}
.main .item {
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid #f2f4f5;
}
.main .left {
  padding: 10px 17px 10px 9px;
}
.main .left img {
  display: inline-block;
  width: 160px;
  height: 100px;
  background: #f2f4f5;
}
.main .right {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.main .right .des {
  display: flex;
  flex-direction: column;
}
.main .right .des .name {
  font-size: 16px;
  color: #333;
}
.main .right .des .price {
  font-size: 14px;
  color: #ff7e00;
  margin-top: 8px;
}
.main .right .des .recruit {
  font-size: 12px;
  color: #b3b3b3;
  margin: 8px 0;
}
.main .right .des p .tag {
  display: inline-block;
  width: 70px;
  height: 20px;
  text-align: center;
  line-height: 20px;
  font-size: 11px;
  background: #f2f4f5;
  color: #c2c8cc;
  margin-right: 12px;
}
.main .right .enroll {
  width: 110px;
  height: 40px;
  display: inline-block;
  font-size: 18px;
  line-height: 40px;
  text-align: center;
  background: #00a0e9;
  color: #fff;
  margin-right: 40px;
}
</style>



// WEBPACK FOOTER //
// src/views/category.vue